import { CONST } from "../CONST";
import BackButton from "../components/BackButton"
import { ProgressiveLoadScene } from "./ProgressiveLoadScene";


export class ArcadeMinigameLoadingScene extends Phaser.Scene {
    private nextScene ?: string;

    private progressiveLoadScene !: ProgressiveLoadScene;

    constructor() {
        super({
            key: CONST.SCENES.ARCADE_MINIGAME_LOADING,
        })
    }

    preload(){}

    init(data: {next: string}) {
        this.progressiveLoadScene = this.registry.get(CONST.SCENES.PROGRESSIVE_LOAD);

        this.nextScene = data.next;
    }

    create(){
        if (this.nextScene) this.progressiveLoadScene.prioritizeChunksWithTag(this.nextScene);

        this.add.image(0,0, CONST.MENU.BACKGROUND).setOrigin(0, 0).setDepth(0);
        new BackButton(CONST.SCENES.MENU, 50, 50, this);

        this.createLoadingText();
        this.createSpinner();       
    }

    createLoadingText(){
        this.add.bitmapText(this.game.renderer.width / 2,
            this.game.renderer.height/2,
            CONST.FONT.ATLAS, "LOADING", 75)
            
            .setOrigin(0.5, 0.25)
            .setDepth(1001)
            .setCenterAlign();
    }

    createSpinner(){
        var spinner = this.add.image(this.game.renderer.width / 2, this.game.renderer.height/2 + 100, CONST.BUTTONS.SPINNER)
        .setDepth(1002)
        .setVisible(true);
    
        this.tweens.add({
            targets: spinner,
            angle: '+=360',
            duration: 1000,
            ease: 'Linear',
            repeat: -1
        });
    }

    update(time: number, delta: number){
        if (!this.nextScene) return;

        if (this.progressiveLoadScene.isSceneLoaded(this.nextScene)){
            this.loadNextScene();
        }
    }

    loadNextScene(){
        this.scene.start(this.nextScene);
    }
}